const roles = {
  superadmin: 'super',
  subadmin: 'sub',
};

export default roles;
